var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 8H4.75C4.15326 8 3.58097 8.23705 3.15901 8.65901C2.73705 9.08097 2.5 9.65326 2.5 10.25V20.375C2.5 20.9717 2.73705 21.544 3.15901 21.966C3.58097 22.3879 4.15326 22.625 4.75 22.625H8.125V27.125C8.125 27.4234 8.24353 27.7095 8.4545 27.9205C8.66548 28.1315 8.95163 28.25 9.25 28.25C9.54837 28.25 9.83452 28.1315 10.0455 27.9205C10.2565 27.7095 10.375 27.4234 10.375 27.125V22.625H26.125V27.125C26.125 27.4234 26.2435 27.7095 26.4545 27.9205C26.6655 28.1315 26.9516 28.25 27.25 28.25C27.5484 28.25 27.8345 28.1315 28.0455 27.9205C28.2565 27.7095 28.375 27.4234 28.375 27.125V22.625H31.75C32.3467 22.625 32.919 22.3879 33.341 21.966C33.7629 21.544 34 20.9717 34 20.375V10.25C34 9.65326 33.7629 9.08097 33.341 8.65901C32.919 8.23705 32.3467 8 31.75 8ZM31.75 17.097L24.903 10.25H31.75V17.097ZM11.597 10.25L21.722 20.375H14.778L4.75 10.347V10.25H11.597ZM4.75 13.528L11.597 20.375H4.75V13.528ZM31.75 20.375H24.903L14.778 10.25H21.722L31.75 20.2794V20.375Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.b54de24a86c725760e925cff930451c3.svg";
export { ForwardRef as ReactComponent };